module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-home.df1aa697.jpg";